import React from "react";
import "./ContactUs.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaClock, FaEnvelopeOpen } from "react-icons/fa";

const ContactUs = () => {
  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  return (
    <div className="contact-page">
      <h2 className="contact-heading">Contact Us</h2>
      <div className="contact-container">
        {/* Map on the left */}
        <div className="contact-map">
          <iframe
            title="IRC Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3751.801785368571!2d75.331411!3d19.89059!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdb980e46b963cb%3A0x1979c94170b4b3c!2sIslamic%20Research%20Centre%20Education%20%26%20Welfare%20Trust%20(IRC)!5e0!3m2!1sen!2sus!4v1749372978438!5m2!1sen!2sus"
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Contact Details on the right */}
        <div className="contact-details">
          <h3>Get In Touch</h3>
          <div className="contact-info">
            <FaMapMarkerAlt className="contact-icon" />
            <div>
              <strong>Address</strong><br />
              H.No 1-23-100, Rohila Gali,<br />
              Chhatrapati Sambhajinagar (Aurangabad) – 431001, Maharashtra, India
            </div>
          </div>

          <div className="contact-info">
            <FaPhoneAlt className="contact-icon" />
            <div
            >
              <strong>Call Us:</strong>     <span
                className="contact-number"
                onClick={() => handlePhoneClick('80-5545-5545')}
                style={{ cursor: 'pointer', color: 'blue' }}
              >+91-80-5545-5545</span><br />
              <strong>A/c Section:</strong> <span
                className="contact-number"
                onClick={() => handlePhoneClick('80-5555-7738')}
                style={{ cursor: 'pointer', color: 'blue' }}
              >+91-80-5555-7738</span>
            </div>
          </div>

          <div className="contact-info">
            <FaClock className="contact-icon" />
            <div>
              <strong>Office Timing</strong><br />
              9 am – 6 pm (Sunday Close)
            </div>
          </div>

          <div className="contact-info">
            <FaEnvelopeOpen className="contact-icon" />
            <div>
              <strong>Email: </strong>
              <a
                className="contact-number"
                href="mailto:islam@irc-india.com"
                style={{ cursor: 'pointer', color: 'blue' }}
              >
                islam@irc-india.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
